import { render } from "./LXSettings.vue?vue&type=template&id=a6f5d716&scoped=true"
import script from "./LXSettings.vue?vue&type=script&lang=js"
export * from "./LXSettings.vue?vue&type=script&lang=js"

import "./LXSettings.vue?vue&type=style&index=0&id=a6f5d716&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a6f5d716"

export default script